import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function PlayIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M3.5 3.393c0-.638 0-.957.128-1.133A.63.63 0 0 1 4.096 2c.213-.012.469.165.98.519l6.667 4.606c.423.293.635.439.709.623a.68.68 0 0 1 0 .504c-.074.184-.286.33-.709.623l-6.666 4.607c-.512.354-.768.53-.98.517a.63.63 0 0 1-.469-.26c-.128-.175-.128-.494-.128-1.132z" /></svg>
  );
}

export default PlayIcon;
